import { Fragment } from 'react';

const ExploreSkeleton = () => {
    return (
        <div className='flex flex-col gap-0.5'>
            {Array.from({ length: 2 }, (_, index) => {
                return (
                    <Fragment key={`skeleton-explore-${index}`}>
                        <div className='grid grid-cols-6 gap-0.5'>
                            <div className='col-span-2 row-span-2 overflow-hidden'>
                                <SkeletonItem />
                            </div>
                            <div className='col-span-2 aspect-square overflow-hidden'>
                                <SkeletonItem />
                            </div>
                            <div className='col-span-2 aspect-square overflow-hidden'>
                                <SkeletonItem />
                            </div>
                            <div className='col-span-2 aspect-square overflow-hidden'>
                                <SkeletonItem />
                            </div>
                            <div className='col-span-2 aspect-square overflow-hidden'>
                                <SkeletonItem />
                            </div>
                        </div>
                        <div dir='ltr' className='grid grid-cols-6 gap-0.5'>
                            <div className='col-span-2 row-span-2 overflow-hidden'>
                                <SkeletonItem />
                            </div>
                            <div className='col-span-2 aspect-square overflow-hidden'>
                                <SkeletonItem />
                            </div>
                            <div className='col-span-2 aspect-square overflow-hidden'>
                                <SkeletonItem />
                            </div>
                            <div className='col-span-2 aspect-square overflow-hidden'>
                                <SkeletonItem />
                            </div>
                            <div className='col-span-2 aspect-square overflow-hidden'>
                                <SkeletonItem />
                            </div>
                        </div>
                    </Fragment>
                );
            })}
        </div>
    );
};

const SkeletonItem = () => {
    return <div className='h-full w-full animate-pulse rounded-2xl bg-gray-300' />;
};

export default ExploreSkeleton;

